/*
 * Copyright (c) 2025. Orion Analytics. All Rights Reserved
 */

// StrategyDetailPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import SideTagMenu from './sideTagMenu';
import {runStrategy} from "../../api";
import { useNavigate, Link } from 'react-router-dom'; // import navigate
import { FaArrowLeft } from 'react-icons/fa'; // for a beautiful curved arrow
import { Sparklines, SparklinesLine, SparklinesSpots } from 'react-sparklines';

const StrategyDetailPage = ({strategyparam}) => {
  // const { key } = useParams();
  const [strategy, setStrategy] = useState(null);
    const [strategies, setStrategies] = useState([]);
  const [selectedStrategy, setSelectedStrategy] = useState(null);

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/ss');
  };

  const iconMap = {
    "52_week_high_breakout": "📈",
    "relative_strength_rs_winners": "💪",
    "price_volume_surge": "🔥",
    "momentum_score": "📊",
    "moving_average_crossover": "🔁",

    "low_pe_high_roe": "📉",
    "magic_formula": "🪄",
    "dividend_yield_focus": "💵",
    "qarp": "🎯",
    "piotroski_f_score": "🧮",

    "high_eps_growth": "🚀",
    "revenue_compounders": "📈",
    "smallcap_stars": "🌟",
    "sector_leaders": "🏆",
    "pat_margin_expansion": "💼",
  };

  useEffect(() => {
      runStrategy(strategyparam.key).then(res => {
      const updated = { ...strategyparam, latest_result: res };
      setStrategy(updated);
    })},[strategyparam]);

  if (!strategy) return <p>Loading...</p>;

  return (
    <div style={styles.detailPage}>
      {/*<SideTagMenu />*/}
      <div style={styles.strategyDetail}>
                {/* Back Button */}
        <button style={styles.backButton} onClick={handleBackClick}>
          <FaArrowLeft />
        </button>

        <h2>{strategy.name} {iconMap[strategy.key] || '📚'} </h2>
        <p>{strategy.description}</p>
        <h4>Screener Logic</h4>
        <p>{strategy.screener_logic}</p>
        <h4>Investment Plan</h4>
        <p>{strategy.investment_plan}</p>

        <h4>Latest Screening Result</h4>
        <table style={styles.table}>
          <thead>
            <tr>
              {strategy.latest_result && Object.keys(strategy.latest_result[0] || {}).map(k => (
                <th style={styles.th} key={k}>{k}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {strategy.latest_result?.map((row, i) => (
              <tr key={i}>
              {Object.entries(row).map(([key, val], j) => (
                  <td style={styles.td} key={j}>
                    {/*{typeof val === 'number' ? val.toFixed(2) : val}*/}
                    {key === 'Symbol' ? (
                  <Link to={`/stock/${val}`} style={{ color: '#007bff', textDecoration: 'none' }}>
                    {val}
                  </Link>
                    ) : key === 'EPS Trend' || key === 'EPS Growth Trend' ? (
            (() => {
              try {
                const values = JSON.parse(val); // convert string to array
                const last = values[values.length - 1];
                return (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                    <Sparklines data={values} width={100} height={20}>
                      <SparklinesLine color="blue" />
                      <SparklinesSpots />
                    </Sparklines>
                    <span style={{ fontSize: '0.75rem' }}>{last.toFixed(2)}</span>
                  </div>
                );
              } catch {
                return 'Invalid data';
              }
            })()
          ): typeof val === 'number' ? val.toFixed(2) : val}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        <h4>Backtest</h4>
        <pre>{strategy.backtest_result || 'Not available'}</pre>
      </div>
    </div>
  );
};

const styles = {
  detailPage: {
    display: 'flex',
  },
  strategyDetail: {
    padding: '24px',
    flex: 1,
    margin: '20px',
    backgroundColor: '#fafafa',
    borderRadius: '12px',
    boxShadow: '0 4px 10px rgba(0, 0, 0, 0.1)',
    border: '1px solid #e0e0e0',
    position: 'relative', // needed to position the back button inside
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    marginTop: '20px',
  },
  th: {
    border: '1px solid #ddd',
    padding: '10px',
    background: '#f5f5f5',
    textAlign: 'left',
    fontWeight: 'bold',
    color: '#333',
  },
  td: {
    border: '1px solid #ddd',
    padding: '10px',
  },
  backButton: {
    position: 'absolute',
    top: '20px',
    right: '20px',
    background: '#007bff',
    color: 'white',
    border: 'none',
    borderRadius: '50%',
    width: '40px',
    height: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    fontSize: '18px',
  },
};
export default StrategyDetailPage;